/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

/* ROUTE BUILDER ROUTES */
export default [
  {
    name: routeNames.CREATE_ROUTE_FISH,
    path: 'route/create',
    component: () => import('@/components/route-builder-card'),
  },
  {
    name: 'fish-route-edit',
    path: 'route/:id/edit',
    component: () => import('@/components/route-builder-card'),
  },
  {
    name: 'fish-route',
    path: 'route/:id',
    component: () => import('@/components/route-view-card'),
  },
]
